<template>
    <l-layout :layout="['xs12']">
      <l-data-table
      :headers="header"
      :get-data-func="getApplList"
      hide-title-search
      title-text="个人申请列表"
      @click:row="getDetails($event.item)"
      clickable></l-data-table>
      <l-fixed-btn
        @click="addApply()"
        icon="$vuetify.icons.add"
      ></l-fixed-btn>
    </l-layout>
</template>

<script>
    import LDataTable from "../../../ladmin/components/LDataTable/LDataTable";
    function reviewStatusTrans(v){
      switch (v+'') {
        case '1':return '通过';
        case '2':return '已拒绝';
        case '0':return '待审核'
        default:return v;
      }
    }
    export default {
        name: "selfApplyList",
        components: {LDataTable},
        data(){
          return {
            header:[
              {text:'教工姓名',value:'name',sortable:false,align:'left'},
              {text:'教工编号',value:'loginId',sortable:false,align:'left'},
              {text:'教工单位',value:'orgName',sortable:false,align:'left',placeholder:'N/A'},
              {text:'计划进校时间',value:'stTime',sortable:true,align:"left"},
              {text:'计划进校事由',value:'reqComment',sortable:true,align:"left",maxWidth: '6em', tooltip: true},
              {text:'二级单位审核状态',value:'firstAuditStatus',sortable:false,align:'left',f:(v)=>reviewStatusTrans(v)},
              {text:'业务部门审核状态',value:'secondAuditStatus',sortable:false,align:'left',f:(v)=>reviewStatusTrans(v)},
              {text:'',value:'',sortable:false,align:'left'}
            ]
          }
        },
      methods:{
        getLoginInfo(){
          return JSON.parse(sessionStorage.getItem('loginInfo'))
        },
        async getApplList({pagination}){
          let filter=[{
            key:'auditType',
            value:'0'
          }]
          let {items,amount} = await this.$store.dispatch('school/getApplyList',{pagination:pagination,filter:filter,search:{key:'loginId',value:this.getLoginInfo().id}})
          return {items:items,amount:amount}
        },
        addApply(){
          this.$router.push({name:'newSelfApply'})
        },
        getDetails(item){
          this.$router.push({name:'ApplyReviewDetailBox',
            query:{
              id:item.id,
              status:'readonly'
            }
          })
        }
      }
    }
</script>

<style scoped>

</style>
